import useReveal from "./useReveal";

// Simple scroll-triggered reveal wrapper. `RevealGroup`/`RevealItem` stagger
// children slightly for card grids; `Reveal` is the plain single-element form.
export const Reveal = ({ as: Tag = "div", className = "", children, ...rest }) => {
  const [ref, isVisible] = useReveal();
  return (
    <Tag ref={ref} className={`reveal ${isVisible ? "is-visible" : ""} ${className}`} {...rest}>
      {children}
    </Tag>
  );
};

export const RevealGroup = ({ className = "", children, ...rest }) => (
  <div className={className} {...rest}>
    {children}
  </div>
);

export const RevealItem = ({ as: Tag = "div", className = "", delay = 0, children, ...rest }) => {
  const [ref, isVisible] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${isVisible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: isVisible ? `${delay}ms` : "0ms" }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
